<template>
    <v-container fluid>
        <h1>Projects</h1>
        <h3>List</h3>
        <div class="row">
            <div class="col-12 col-lg-6 col-md-6" v-for="(project, index) in projects" :key="index">
                <a :href="'http://' + project.link" target="_blank" class="mb-4 v-card v-card--link theme--light" >
                    <v-img
                        :src="'projects/' + project.photo"
                        contain
                    >
                    </v-img>
                    <div class="v-card__title white align-start">
                        <h5>{{ project.title }}</h5>
                        <div class="spacer"></div>
                        <v-chip v-for="tag in project.category" :key="tag">
                            {{ tag }}
                        </v-chip>
                    </div>
                    <div class="v-card__text pb-2 pt-0">
                        <p>{{ project.desc }}</p>
                    </div>
                </a>
            </div>
        </div>
    </v-container>
</template>

<script>
    import projects from "../../db.json"
    export default {
        name: "Projects",
        data() {
            return {
                projects: projects
            }
        }
    }
</script>

<style scoped>
    .v-application .vue {
        background-color: #41B883 !important;
        border-color: #41B883 !important;
    }
    .vue--text{
        color: #2B3C4E !important;
        caret-color: #2B3C4E !important;
    }
</style>